export default Object.freeze({
  PICTURES: 'Photos',
  MATERIAL: 'Empreintes physiques',
  INTERNAL_SCAN: 'Empreintes fichiers STL',
  EXTERNAL_SCAN: 'Empreintes liens STL',
  OLD_TREATMENT: 'Empreintes sur traitement',
});
